/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import React from "react";
import { useLockBodyScroll } from "react-use";
import { Sidebar as GNUISidebar } from "@nordcloud/gnui";

type Props = {
  children?: React.ReactNode;
  title?: string;
  caption?: string;
  isOpen: boolean;
  side?: "onLeft" | "onRight";
  width?: number | string;
  reverse?: boolean;
  onClick?: () => void;
  showExpandButton?: boolean;
  onExpandClick?: () => void;
  footer?: React.ReactNode;
  headerStyles?: React.CSSProperties;
  contentStyles?: React.CSSProperties;
};

export function Sidebar({
  children,
  title,
  caption,
  isOpen,
  side,
  width,
  reverse,
  onClick,
  showExpandButton,
  onExpandClick,
  footer,
  headerStyles,
  contentStyles,
}: Props) {
  useLockBodyScroll(isOpen);

  const defaultHeaderStyles = {
    zIndex: 10,
  };

  return (
    <GNUISidebar
      title={title}
      isOpen={isOpen}
      caption={caption}
      side={side}
      width={width}
      reverse={reverse}
      onClick={onClick}
      showExpandButton={showExpandButton}
      onExpandClick={onExpandClick}
      footer={footer}
      headerStyles={{
        ...defaultHeaderStyles,
        ...headerStyles,
      }}
      contentStyles={contentStyles}
    >
      {children}
    </GNUISidebar>
  );
}
